/* ============
 * Actions for the patient module
 * ============
 *
 * The actions that are available on the
 * patient module.
 */
import PatientProxy from '@/proxies/PatientProxy';
import types from './mutation-types';

export const getPatientProgresses = ({ commit }, data) => {
  commit(types.FETCH_PATIENT_PROGRESS_LIST);
  new PatientProxy().fetchPatientProgresses(data)
    .then(({ totalCount, patientProgress }) => {
      commit(types.FETCH_PATIENT_PROGRESS_LIST_SUCCESS, {
        totalCount,
        patientProgress
      });
    }).catch((error) => {
      commit(types.FETCH_PATIENT_PROGRESS_LIST_FAIL, error);
    });
};

export const getPatientProgressDetails = ({ commit }, id) => {
  commit(types.FETCH_PATIENT_PROGRESS);
  new PatientProxy().fetchProgressDetails(id)
    .then((patientProgress) => {
      commit(types.FETCH_PATIENT_PROGRESS_SUCCESS, patientProgress);
    }).catch((error) => {
      commit(types.FETCH_PATIENT_PROGRESS_FAIL, error);
    });
};

export const getPatientProgressByCycle = ({ commit }, data) => {
  commit(types.FETCH_PATIENT_PROGRESS_BY_CYCLE);
  new PatientProxy().fetchProgressDetailsByCycle(data)
    .then((patientProgress) => {
      commit(types.FETCH_PATIENT_PROGRESS_BY_CYCLE_SUCCESS, patientProgress);
    }).catch((error) => {
      commit(types.FETCH_PATIENT_PROGRESS_BY_CYCLE_FAIL, error);
    });
};

export const resetPatientProgress = ({ commit }) => {
  commit(types.RESET_PATIENT_PROGRESS);
};

export default {
  getPatientProgresses,
  getPatientProgressDetails,
  resetPatientProgress,
  getPatientProgressByCycle
};
